/* Tab switching for the product comparison.

   The markup is already a working tab set before this runs: every panel
   is in the page, the open one is shown and the rest carry hidden. With
   the script off you get three headings and three panels, which is a
   worse comparison but not a broken page.

   What this adds is the switching, and the keyboard behaviour a tablist
   is supposed to have - arrows move between tabs, Home and End jump to
   the ends, and only the open tab is in the tab order, so Tab takes you
   past the set into the panel rather than through three buttons. */

(function () {
  function init(root) {
    var list = root.querySelector('[role="tablist"]');
    if (!list) return;

    var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
    if (tabs.length < 2) return;

    var panels = tabs.map(function (tab) {
      return root.querySelector('#' + CSS.escape(tab.getAttribute('aria-controls')));
    });

    function open(index, moveFocus) {
      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.classList.toggle('is-open', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;

        var panel = panels[i];
        if (!panel) return;
        panel.classList.toggle('is-open', on);
        if (on) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
      });
      if (moveFocus) tabs[index].focus();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { open(i); });

      tab.addEventListener('keydown', function (event) {
        var next = null;
        switch (event.key) {
          case 'ArrowRight':
          case 'ArrowDown': next = (i + 1) % tabs.length; break;
          case 'ArrowLeft':
          case 'ArrowUp':   next = (i - 1 + tabs.length) % tabs.length; break;
          case 'Home':      next = 0; break;
          case 'End':       next = tabs.length - 1; break;
          default: return;
        }
        event.preventDefault();
        open(next, true);
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-oj-cmp]').forEach(function (root) {
      if (root.dataset.ojCmpReady) return;
      root.dataset.ojCmpReady = '1';
      init(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // The theme editor re-renders a section in place when a setting changes.
  document.addEventListener('shopify:section:load', boot);
})();
